import { Button, ButtonLink } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import styles from "@/styles/Video.module.scss";
import { useViewingArticle } from "@/hooks";
import CourseInfo from "./CourseInfo";
import ProductInfo from "./ProductInfo";
import { useCallback } from "react";

export default function NeedLogin({ watch, withContract }) {
  const { setViewingArticle, loading } = useViewingArticle();
  const { episode, howtoPlay } = watch;

  const handleClick = useCallback(() => {
    if (episode.rights_control_type === "entitled_only") {
      const viewingArticlePayload = (() => {
        if (howtoPlay.courses.length > 0) {
          return {
            type: "svod",
            id: howtoPlay.courses.map((c) => Number(c.id)),
          };
        } else if (howtoPlay.products.length > 0) {
          return {
            type: "tvod",
            id: howtoPlay.products.map((p) => Number(p.id)),
          };
        }
      })();
      setViewingArticle(viewingArticlePayload, false, routes.login);
    } else {
      window.location.href = routes.login;
    }
  }, [episode]);

  const isMemberFree =
    episode?.rights_control_type === "member_only" &&
    episode?.rights[0]?.price === 0;

  const headerMessage = (() => {
    if (isMemberFree) {
      return "この作品をご視聴いただくには会員登録が必要です";
    } else if (howtoPlay.courses.length > 0) {
      return "この作品をご視聴いただくには会員登録と以下の月額商品の購入が必要です";
    } else {
      return "この作品を購入するには会員登録が必要です";
    }
  })();

  return (
    <>
      <div className="needlogin">
        <h3>{headerMessage}</h3>
        <Button
          fillColor
          large
          className={styles.overlayRegistBtn}
          onClick={handleClick}
        >
          無料で会員登録する
        </Button>
        <ul className={styles.note}>
          <li>作品の購入には所定の料金がかかります。</li>
          <li>
            サービスをお楽しみいただくためにはお支払い方法のご登録が必要です。
          </li>
        </ul>
        <div className={styles.login}>
          <span>既に会員の方</span>
          <ButtonLink href={routes.login} borderGray fontFixed fontBold>
            ログインする
          </ButtonLink>
        </div>
        {withContract && howtoPlay.courses.length > 0 && (
          <div className={styles.contractInfo}>
            {howtoPlay.courses.length > 0 &&
              howtoPlay.courses.map((course) => (
                <CourseInfo
                  key={`course-${course.id}`}
                  course={course}
                  isLoggedIn={false}
                />
              ))}
          </div>
        )}
        {withContract && howtoPlay.products.length > 0 && (
          <div>
            {howtoPlay.products.map((product) => (
              <ProductInfo
                key={`product-${product.id}`}
                product={product}
                rights={howtoPlay.rights}
                isLoggedIn={false}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
